import { render, staticRenderFns } from "./add-invoice-company.vue?vue&type=template&id=48aec7b8&scoped=true&"
import script from "./add-invoice-company.vue?vue&type=script&lang=js&"
export * from "./add-invoice-company.vue?vue&type=script&lang=js&"
import style0 from "./add-invoice-company.vue?vue&type=style&index=0&id=48aec7b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aec7b8",
  null
  
)

export default component.exports